import { render, staticRenderFns } from "./ota.vue?vue&type=template&id=feb98a28&scoped=true"
import script from "./ota.vue?vue&type=script&lang=js"
export * from "./ota.vue?vue&type=script&lang=js"
import style0 from "./ota.vue?vue&type=style&index=0&id=feb98a28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb98a28",
  null
  
)

export default component.exports